import React from "react";
import Bg from "@/assets/images/product/counseling/bg.jpeg";
import consultBg1 from "@/assets/images/product/counseling/consult1.png";
import consultBg2 from "@/assets/images/product/counseling/consult2.png";

const Counseling: React.FC = () => {
  return (
    <main className='warp-consult header-top'>
      <div className='warp-consult-header'>
        <img src={Bg} alt=""/>
      </div>
      <div className='warp-consult-manage' style={{minHeight: '900px'}}>
        <div className='home-page'>
          <div className='title'>党建品牌创建</div>
          <div className='desc'>依托成熟五步品牌创建法 + 六步阵地落地法，覆盖党建顶层规划、体系搭建、空间落地全链条服务，从软件制度体系到硬件阵地空间双向落地，帮助企业构建标准化、可视化、品牌化的党建基础底盘。</div>
          <div className='c-ling-bg'>
            <img src={consultBg1} alt=""/>
          </div>
        </div>
      </div>
      <div className='warp-consult-finance' style={{minHeight: '1000px'}}>
        <div className='home-page'>
          <div className='title'>党建阵地建设</div>
          <div className='desc'>线下实体阵地规划、空间装修布展、营区氛围打造 + 线上党建云平台定制开发，从前期规划、需求调研、内容整合到落地验收全六步闭环落地，建成可参观、可学习、可活动、可展示、可传播的多功能红色阵地。</div>
          <div className='c-ling-bg'>
            <img src={consultBg2} alt=""/>
          </div>
        </div>
      </div>
    </main>
  )
}

export default Counseling